export default __webpack_public_path__ + "static/media/5 - Matt McKenzie.4333aaa3.jpg";